import React from "react";
import "./FloatingSocial.css"; // Crea este archivo para los estilos

export const FloatingSocial = () => (
  <div className="redes-flotantes">
    <a
      href="https://t.me/juliocsg93"
      target="_blank"
      rel="noopener noreferrer"
      className="social-icon"
    >
      <img
        src="img/icons/telegram-icon.png"
        alt="Telegram"
        width={59}
        height={59}
      />
    </a>
    <a
      href="https://api.whatsapp.com/send?phone=595961383306&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n%20del%20alquiler%20de%20quincho."
      target="_blank"
      rel="noopener noreferrer"
      className="social-icon"
    >
      <img
        src="img/icons/whatsapp-icon.png"
        alt="WhatsApp"
        width={59}
        height={59}
      />
    </a>
  </div>
);